function layout(linhasComprovantes) {
  const comandos = []

  comandos.push({ tipo: "comando_alinhar_ao_centro", valor: "" });

  for (let j = 0; j < linhasComprovantes.length; j++) {
    comandos.push({ tipo: "imprimir_texto", valor: linhasComprovantes[j] });
    comandos.push({ tipo: "imprimir_texto", valor: "\n" });
  }

  //comandos.push({ tipo: "comando_generico", valor: "1B69" });

  return { comandos };
}

export default layout;
